'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.135 16.217v1.007h-.672v-1.007h.672Zm0-3.492v2.095h-.672v-2.095h.672Zm-8.824.046v1.008H9.64v-1.008h.671Zm0-3.511v2.107H9.64V9.26h.671Zm8.824-.027v2.095h-.672V9.233h.672Zm-8.824-3.485v2.107H9.64V5.748h.671Zm8.824-.007v2.095h-.672V5.741h.672Zm-8.151-2.74v.67h-.672v.672H9.64V3.337c0-.187.15-.337.336-.337h1.008Zm7.815 0c.186 0 .336.15.336.336v1.006h-.672v-.671h-.67V3h1.006ZM13.82 3v.672h-1.702V3h1.702Zm2.837 0v.672h-1.702V3h1.702Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.605 9.528v3.568h.937V11.16h.672v1.937h1.245c.186 0 .336.151.336.336v1.543h4.827c.185 0 .335.15.335.336v1.577h6.05c.134 0 .254.078.308.2l.656 1.477a.335.335 0 0 1-.306.473h-.54v1.587a.337.337 0 0 1-.336.336h-7.992a.336.336 0 0 1-.335-.336v-1.587h-.54a.337.337 0 0 1-.307-.473l.656-1.478a.337.337 0 0 1 .307-.199h1.708v-1.242H3.672v4.643h6.593v.672h-6.93A.337.337 0 0 1 3 20.625v-5.314c0-.186.15-.336.336-.336h.736v-1.543c0-.185.15-.336.335-.336h.526V9.528h.672Zm13.848 9.51h-7.32v1.251h7.32v-1.252Zm-14.003-.77c.124 0 .224.1.224.224v.866c0 .123-.1.223-.224.223h-.209a.223.223 0 0 1-.224-.223v-.866c0-.124.1-.224.224-.224Zm1.532 0c.124 0 .224.1.224.224v.866c0 .123-.1.223-.224.223h-.209a.223.223 0 0 1-.224-.223v-.866c0-.124.1-.224.224-.224Zm1.533 0c.124 0 .224.1.224.224v.866c0 .123-.1.223-.224.223h-.21a.223.223 0 0 1-.223-.223v-.866c0-.124.1-.224.224-.224Zm11.275-.708h-.38l.238.806h.5l-.358-.806Zm-7.613 0h-.38l-.36.806h.5l.24-.806Zm6.766 0h-.685l.12.806h.803l-.238-.806Zm-1.137 0h-.67l.06.806h.729l-.12-.806Zm-1.118 0h-.671v.806h.73l-.06-.806Zm-1.12 0h-.67l-.06.806h.73v-.806Zm-1.12 0h-.667l-.12.806h.729l.059-.806Zm-1.12 0h-.684l-.24.806h.805l.119-.806Zm-5.205-3.792h-3.38v1.207h3.38v-1.207ZM5.565 4.296l.55.384c-.311.448-.604.952-.644 1.108.032.111.205.403.31.58.253.422.395.671.395.887 0 .304-.4 1.167-.637 1.655l-.603-.295c.254-.52.535-1.173.567-1.352-.031-.104-.197-.382-.298-.55-.253-.426-.408-.698-.408-.924 0-.324.418-.99.768-1.493Z",
    fill: "#87868F"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.97 10.035c0-.096.025-.168.076-.217.051-.049.126-.074.224-.074.095 0 .168.025.22.076.052.05.078.122.078.215 0 .09-.027.161-.079.213a.3.3 0 0 1-.219.078.308.308 0 0 1-.222-.076.285.285 0 0 1-.079-.215Zm.054-.585v-.126c0-.11.023-.205.07-.286a.92.92 0 0 1 .256-.258c.12-.086.2-.155.237-.209a.3.3 0 0 0 .057-.179.194.194 0 0 0-.082-.17.395.395 0 0 0-.229-.058c-.17 0-.366.056-.585.168l-.186-.375c.254-.142.524-.214.81-.214.234 0 .42.057.56.17a.554.554 0 0 1 .207.451.6.6 0 0 1-.086.325 1.216 1.216 0 0 1-.325.308 1.009 1.009 0 0 0-.207.185.278.278 0 0 0-.044.165v.103h-.453Z",
    fill: "currentColor"
  })));
});
var FwSet0IndustryDontKnow = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0IndustryDontKnow = FwSet0IndustryDontKnow;